var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sheet-row"},[_c('div',{staticClass:"sheet-row-line"},[_c('span',{staticClass:"sheet-row-label"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),_c('div',{staticClass:"sheet-row-value"},[_vm._t("default")],2)]),(_vm.$scopedSlots.sub)?_c('div',{staticClass:"sheet-row-sub"},[_vm._t("sub")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }